import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";

import { getCurrentCulture } from "@utils";
import { useRootAppStore } from "@hooks";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import { EventBodyTabs } from "@data-types/offer/event/EventViewStoreEnums";

import { EventContentToggleButton } from ".";

export default observer(function MyBetsToggleButton(props: {
	store: EventViewStore | AdditionalOfferViewStore;
}) {
	const rootStore = useRootAppStore();

	const { t } = useTranslation("mybets");

	if (!rootStore.userAuthStore.isLoggedIn) {
		return null;
	}

	return (
		<EventContentToggleButton
			title={t(
				getCurrentCulture() === "de"
					? "PAGE.ADDITIONAL_OFFER_TITLE"
					: "COMMON.MY_BETS_TITLE"
			)}
			isActive={props.store.currentTab === EventBodyTabs.MyBets}
			onClick={() => props.store.openTab(EventBodyTabs.MyBets)}
		/>
	);
});
